export const OTHER_PUBLISHER_ID = 'OTHER';
